// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"2c9a2897","187":"61467d8a","215":"4d4c561b","237":"c7d9c037","238":"74e369b1","415":"1f31500b","453":"e9874340","476":"4ef60454","478":"f4d8969f","548":"c129121e","559":"d5ff54cf","698":"06a3f502","708":"102e3317","771":"89969371","957":"8ae80c56"}[chunkId] + ".chunk.js";
};